import { Component } from '@angular/core';
import { ViewController, Events } from 'ionic-angular';
import { NavParams } from 'ionic-angular/navigation/nav-params';
import { LocationsProvider } from '../../providers/locations/locations';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { SoundsProvider } from '../../providers/sounds/sounds';

/**
 * Generated class for the CoPopoverReserveFilterComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-popover-reserve-filter',
  templateUrl: 'co-popover-reserve-filter.html'
})
export class CoPopoverReserveFilterComponent {
  filterShow: string;
  text: string;
  // timeRange: any = { lower: 0, upper: 24 };
  // displayTime: any;
  allLocations: any;
  includedLocations: any = {};
  filterKeyword: any;
  currentFilters: any;
  keywordTextValue: string;

  constructor(public viewCtrl: ViewController, public navParams: NavParams, public locationsProvider: LocationsProvider, private events : Events, private timeout : TimeoutFunctionsProvider, private sounds : SoundsProvider) {
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    this.filterShow = this.navParams.data.data;
    let appliedFilters = this.navParams.data.current;
    locationsProvider.getLocations().then((res) => {
      this.allLocations = res;
      this.allLocations.forEach(loc => {
        if (appliedFilters.location && appliedFilters.location.includes(loc.id.toString())){
          this.includedLocations[loc.id] = true;
        } else {
          this.includedLocations[loc.id] = false;
        }
      });
    });
    this.keywordTextValue = appliedFilters.keyword;
  }

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }

  setKeyword(event) {
    if (event.target && event.target.value.length > 0) {
      this.filterKeyword = event.target.value.toLowerCase();
      this.close('keyword', this.filterKeyword, true);
    } else {
      this.filterKeyword = ""
      this.close('keyword', this.filterKeyword, false);
    }
  }

  setLocations(all) {
    let locationArray = [];
    // console.log(this.includedLocations);
    if (!all) {
      let empty = true;
      for (let location in this.includedLocations) {
        if (this.includedLocations[location] === true) {
          empty = false;
          locationArray.push(location)
        } else {
          this.includedLocations[location] = false;
        }
        // this.includedLocations[location] === true ? locationArray.push(location) : false;
      };
      if (empty) {
        this.setLocations(true);
        return;
      }
      this.close('location', locationArray, true)
    } else if (all) {
      for (let location in this.includedLocations) {
        locationArray.push(location)
      };
      this.close('location', locationArray, false)
    } else {
      console.log('you should not see this, something else wrong with locations list')
    }
  }

  resetAll(event){
    this.close("resetAll","",false);
  }

  close(tab, info, active) {
    this.viewCtrl.dismiss({ type: tab, stats: info, on: active }).catch(err=>{});
  };

}



// WEBPACK FOOTER //
// ./src/components/co-popover-reserve-filter/co-popover-reserve-filter.ts